import React, { Component } from "react";
import { connect } from 'react-redux';
import { Title, Body, Subtitle } from '@vds/typography';
import { Line } from '@vds/lines';
import { Grid, Row, Col } from '@vds/grids';
import styled from 'styled-components';
import { MarginSpacerL, MarginSpacerS, MarginSpacerXL, MarginTopSpacerL } from '../styleTag';
import { spacers } from '@vds/theme';
import { Button } from '@vds/buttons';
// import * as SiteAnalytics from '../../sitecatalyst';
import { getConfirmationOrder } from '../../Confirmation/containers/actions';
// import { isMobileOnly } from 'react-device-detect';
// import { refreshChatHashTag } from '../../utils/common';
import * as SiteAnalytics from '../../../sitecatalyst';
import * as ChatAnalytics from '../../../utils/lpchatMetrics';
// style sheet...
import '../../Confirmation/Confirmation.css';
import * as SiteAnalyticsOmni from '../../../sitecatalyst/omniDl';
// override vds components...
const RequestCol = styled(Col)`
  margin-bottom:  ${spacers.medium} !important;
  padding-left: 0px;
`;

const ZipCodeRow = styled(Row)`
@media (max-width: 600px) {
    margin-bottom:15px;
}
`;


class ConfirmationContactRep extends Component {
    constructor(props) {
        super(props);

        this.state = {
            endInteraction: false,
        };
        window.scrollTo(0, 0);
    }

    componentWillMount() {
        this.props.getOrderStatus();
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.orderInfo !== this.props.orderInfo) {
            SiteAnalytics.trackOrderConfirmation({orderInfo: nextProps.orderInfo || {}, floatCartInfo: nextProps.floatCartResponse});
        }
    }
    
    componentDidMount() {
        SiteAnalyticsOmni.purchaseEvent("confirmation-contact-rep", this.props);
        SiteAnalytics.trackPageInfo('OrderConfirmation');
        ChatAnalytics.setPurchaseTracking(this.props.floatCartResponse, this.props.orderInfo?.svc_orderNo);
        this.setState({ endInteraction: true });
    }

    componentDidUpdate = () => {
        if(this.state.endInteraction && navigator?.userAgentData?.platform !== "macOS") {
            window.newrelic.interaction().end();
            this.setState({ endInteraction: false });
        }
    }

    render() {
        // wrappers...
        const SectionWrapper = styled.section`
            margin-top: 1rem;
			width: 100%;
        `;
        const ArticleWrapper = styled.article`
            margin-top: 0.5rem;
            width: 100% !important;
         `;

        // Variables Destructuring...
        const {
            firstName,
            lastName,
            address,
            zipCode,
            city,
            state,
            companyName,
            orderNumber,
            orderInfo,
        } = this.props;

        return (
            <Grid className="confirmation-page" colGutter={true}>
                {/* <Row>
                    <Col colSizes={{ "mobile": 4, "tablet": 12, "desktop": 12 }}>
                        <div className="page-title">
                            <Title size="large" primitive="h2">
                                Thank you for your order.
							</Title>
                            <div className="sub-title-content">
                                <Subtitle primitive="h4">
                                    Your order number is <b> {orderNumber} </b>
                                </Subtitle> <br />
                                <Subtitle primitive="h4">
                                    You will receive an email with this summary and an estimate of your monthly bill within 24 hours.
                                </Subtitle>
                            </div>
                        </div>
                    </Col>
                </Row> */}
                <Row >
                    {/* <Col colSizes={{ "mobile": 4, "tablet": 12, "desktop": 3 }}>
                        <Line type="light" noMargin />
                        <SectionWrapper>
                            <Title size="medium" primitive="h6" bold={true}>
                                Business details
                            </Title>
                            <ArticleWrapper>
                                <Row>
                                    <div className="customer-name">
                                        <Col>{firstName} {lastName}</Col>
                                    </div>
                                </Row>
                                <Row>
                                    <div className="company-name">
                                        <Col> {companyName}</Col>
                                    </div>
                                </Row>
                                <Row>
                                    <Col> {address}</Col>
                                </Row>
                                <Row>
                                    <Col> {city}, {state}</Col>
                                </Row>
                                <ZipCodeRow>
                                    <Col>{zipCode}</Col>
                                </ZipCodeRow>
                            </ArticleWrapper>

                        </SectionWrapper>
                    </Col> */}
                    <Col colSizes={{ "mobile": 4, "tablet": 12, "desktop": 9 }}>
                        <Line type="light" noMargin />
                        <SectionWrapper>
                            <div className="contact-rep-container">
                                <Grid colSizes={{ desktop: 12, tablet:12, mobile: 4 }}>
                                    <Row>
                                        <Col colSizes={{ desktop: 12, tablet:12,mobile: 4 }}>
                                            <MarginTopSpacerL></MarginTopSpacerL>
                                            <MarginSpacerL>
                                                <Title size="large" typescale="MVP">Call us</Title>
                                            </MarginSpacerL>
                                            <MarginSpacerS>
                                                <Body size="large" typescale="MVP">We need additional information to set up an installation date for your order.</Body>
                                            </MarginSpacerS>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col colSizes={{ desktop: 3, tablet:12,mobile: 4 }}>
                                            <Line type="light"></Line>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col colSizes={{ desktop: 12, tablet:12,mobile: 4 }}>
                                            <MarginSpacerL>
                                                <Title size="small" typescale="MVP">Order details</Title>
                                            </MarginSpacerL>
                                            <MarginSpacerS>
                                                <Body size="large" typescale="MVP" bold>Order #</Body>
                                            </MarginSpacerS>
                                            <MarginSpacerXL>
                                                <Body size="large" typescale="MVP">{orderInfo?.svc_orderNo}</Body>
                                            </MarginSpacerXL>
                                            <MarginSpacerS>
                                                <Body size="large" typescale="MVP" bold>Customer reference number</Body>
                                            </MarginSpacerS>
                                            <MarginSpacerXL>
                                                <Body size="large" typescale="MVP">{orderInfo?.Refno}</Body>
                                            </MarginSpacerXL>
                                            <MarginSpacerS>
                                                <Body size="large" typescale="MVP" bold>Customer Service</Body>
                                            </MarginSpacerS>
                                            <MarginSpacerXL>
                                                <Body size="large" typescale="MVP">1-866-424-9066</Body>
                                            </MarginSpacerXL>
                                            <Body size="large" typescale="MVP">Monday to Friday</Body>
                                            <MarginSpacerL>
                                                <Body size="large" typescale="MVP">8:00AM - 10:00PM EST</Body>
                                            </MarginSpacerL>
                                            <Body size="large" typescale="MVP">Saturday</Body>
                                            <MarginSpacerL>
                                                <Body size="large" typescale="MVP">8:00AM - 9:30PM EST</Body>
                                            </MarginSpacerL>
                                            <Body size="large" typescale="MVP">Sunday</Body>
                                            <MarginSpacerXL>
                                                <Body size="large" typescale="MVP">11:00AM - 9:30PM EST</Body>
                                            </MarginSpacerXL>
                                            {/* <MarginSpacerXL>
                                                <Button size='large' width="200px">Call</Button>
                                            </MarginSpacerXL> */}
                                        </Col>
                                    </Row>
                                </Grid>
                            </div>
                        </SectionWrapper>
                    </Col>
                </Row>
            </Grid>

        );
    }

}

const mapStateToProps = (state) => {
    const { CheckoutPage, Confirmation, ReviewOrderPage, CustomizeOrder } = state;
    return {
        firstName: CheckoutPage?.contactInfo?.firstName || '',
        lastName: CheckoutPage?.contactInfo?.lastName || '',
        address: CheckoutPage?.contactInfo?.address || '',
        zipCode: CheckoutPage?.contactInfo?.zipCode || '',
        city: CheckoutPage?.contactInfo?.city || '',
        state: CheckoutPage?.contactInfo?.state || '',
        companyName: CheckoutPage?.contactInfo?.businessName || '',
        orderNumber: Confirmation?.getConfiramtionOrderInfoResponse?.Ord?.svc_orderNo || '',
        dueDate: CheckoutPage?.dueDate || '',
        timeSlotCode: CheckoutPage?.timeSlotCode || '',
        appointmentCode: CheckoutPage?.appointmentCode || '',
        orderInfo: Confirmation?.getConfiramtionOrderInfoResponse?.Ord,
        cartInfo: ReviewOrderPage?.getCartInfoSuccessResponse,
        floatCartResponse: CustomizeOrder.getFloatCartResponse,
    };
};

const mapDispatchToProps = (dispatch) => ({
    getOrderStatus: () => {
        dispatch(getConfirmationOrder());
    },

});
ConfirmationContactRep = connect(mapStateToProps, mapDispatchToProps)(ConfirmationContactRep);
export default ConfirmationContactRep;